module.exports = __webpack_public_path__ + "static/media/3.fbe28a71.png";